import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { Divider } from "@mui/material";
import Cookies from "js-cookie";
// import Banner from "../Banner";
// import banner from "../../assets/images/banner-hop-days.png"; // Adjust path if needed

function BlogDetails({initialData={}, language }) {
  console.log("BlogDetails:", initialData);
  // const { ID } = useParams();
  
  const [fontSize, setFontSize] = useState("20px");
    const [lineHeight, setLineHeight] = useState("10");
  const [blog, setBlog] = useState(initialData?.blog?.data);
  const [trendingBlogs, setTrendingBlogs] = useState(initialData?.recent?.data || []);
  const [loading, setLoading] = useState(!initialData?.blog?.data);
  const [currency, setCurrency] = useState(initialData?.currency?.data || []);
const location =useLocation()
console.log("location",location.pathname)
const match = location?.pathname?.match(/-([a-f0-9]{24})$/);
const ID = match ? match[1] : null;


  // console.log("ID:", ID);



  // console.log("currency2",currency2)
  useEffect(() => {
    if (!initialData?.blog?.data) {
      const fetchData = async () => {
        try {
          // Fetch blog data
          const blogResponse = await fetch(`https://admin.hopdays.com/api/blogs/${ID}`);
          const blogData = await blogResponse.json();
          setBlog(blogData.data);
          
          // Fetch recent blogs
          const recentResponse = await fetch(`https://admin.hopdays.com/api/recent-blogs?language=${language}`);
          const recentData = await recentResponse.json();
          setTrendingBlogs(recentData.data);
          
          // Fetch currency data
          const currencyResponse = await fetch(`https://admin.hopdays.com/api/currency/all`);
          const currencyData = await currencyResponse.json();
          setCurrency(currencyData.data);
          
          setLoading(false);
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false);
        }
      };
      
      fetchData();
    }
  }, [ID, initialData]);
  function truncateText(text, maxLength) {
    if (text?.length <= maxLength) {
        return text;
    }
    return text?.substring(0, maxLength) + '...';
}

  const currency2 = currency?.find((item) => item.name === language || "en") 
  let url = `inspire/${blog?.countryData?.name?.toLocaleLowerCase().replace(/\s+/g, '-')}/${blog?.slug?.toLocaleLowerCase().replace(/\s+/g, '-') || "slug"}-${blog?._id}`;
 const navigate = useNavigate()
 const styledAnswer = blog?.description?.replace(
  /<span[^>]*>/g,
  `<span style=" line-height: ${lineHeight};">`
);

 const sanitizeAnswer = (answer, language) => {
  return answer?.replace(/\{(\d+)\}/g, (match, number) => {
    return language === "ar" && currency2?.value
      ? `SAR ${Number(number) * currency2?.value}`
      : `USD ${Number(number) * currency2?.value}`;
  });

 
};
  return (
    <div>
      <NavBar language={language || Cookies.get("lang")}/>
      {language==="ar" && blog?.isForArabic==="no" ? (
        <div className="flex justify-center items-center h-screen">This Blog Is not Available In Selected Language</div>
      ) : (
<div>

<div className="container mx-auto lg:px-6 max-sm:px-2 py-4 flex flex-col md:flex-row gap-8">

{/* Trending Blogs for Desktop */}
<aside className="w-full md:w-1/4 mt-10 md:mt-20 max-sm:hidden px-2">
  <h2 className="text-xl font-semibold mb-4">Recent Blogs</h2>
  <div className="space-y-4 ">
    {trendingBlogs.length > 0 ? (
      trendingBlogs?.map((post) => (
        <>
     
      <div className=" cursor-pointer" onClick={() => {
            // setBlog(null);
            // ID = post._id;
            setBlog(post);
            navigate(language === "ar" ? `/ar/${`inspire/${post?.countryData?.name?.toLocaleLowerCase().replace(/\s+/g, '-')}/${post?.slug?.toLocaleLowerCase().replace(/\s+/g, '-') || "slug"}-${post?._id}`}` : `/en/${`inspire/${post?.countryData?.name?.toLocaleLowerCase().replace(/\s+/g, '-')}/${post?.slug?.toLocaleLowerCase().replace(/\s+/g, '-') || "slug"}-${post?._id}`}`);
          }}>

    
        <div>
                       <img src={post.headerImage[0].thumbUrl || "/images/latestBlog.png"} alt="Blog Cover" className="w-full h-48  object-cover rounded-t-xl" />
                   </div>
                   <div className={`ms-2 mt-4 ${language === "ar" ? "text-right me-2" : "text-left"}`}>
                       <p className="font-medium text-[18px] max-sm:text-[20px]">{language==="ar"?truncateText(post?.ar_title,50):truncateText(post?.title,50)}</p>
                       <p className="font-medium text-[16px] max-sm:text-[12px] text-gray-500 leading-5 max-sm:leading-3 mt-3 max-sm:mt-3 lg:mb-4"
                            >{language==="ar"? truncateText(post.ar_subDescription,50) : truncateText(post.subDescription,50)}</p>
                       {/* <Link to={`/blog/${blog.ID}`}  className="text-[#5B27D5] font-medium text-[18px] max-sm:text-[12px] lg:mt-1 max-sm:mt-2">
                           {Cookies.get("lang") === "ar" ? "قراءة المقال" : "Read Article"}{" "}
                           <KeyboardArrowRightIcon sx={{ fontSize: "18px", transform: Cookies.get("lang") === "ar" ? "rotate(180deg)" : "none" }} />
                       </Link> */}
                   </div>
                   </div>
                   <Divider/>
                   </>
      ))
    ) : (
      <p className="text-gray-500">Loading trending blogs...</p>
    )}
  </div>
</aside>

{/* Main Blog Content */}
<div className="w-full md:w-3/4 lg:mt-6 lg:mt-20 px-2">
  {loading || !blog ? (
    <p className="text-lg">Loading...</p>
  ) : blog ? (
    <>
    

      <h1 className="text-2xl sm:text-3xl font-bold lg:mb-4">{language==="ar" ? blog?.ar_title : blog?.title}</h1>

      <div className={`flex flex-wrap lg:gap-3 mt-3 max-sm:gap-2 ${language === "ar" ? "flex-row-reverse" : ""}`}>
        {blog?.categoryData?.map((tag,key) => (
          <div key={key} className="border text-[15px] border-[#A5A5A5] px-4 rounded-md"> {/* Unique key */}
            {language === "ar" ? tag.ar_categoryName : tag?.categoryName}
          </div>
        ))}
      </div>

      {blog?.headerImage?.[0]?.thumbUrl && (
        <img
          src={blog?.headerImage[0].thumbUrl}
          // alt="Feature"
          className="w-full  sm:h-96 object-cover rounded-xl lg:mb-6 lg:mt-3 max-sm:-mt-14"
        />
      )}

      <div
         dangerouslySetInnerHTML={{
          __html: `<div class="override-htmlq">${sanitizeAnswer(
            styledAnswer || "",
            language
          )}</div>`,
        }}
        className="lg:mt-4 max-sm:-mt-14 text-base sm:text-lg leading-relaxed"
      />

      {blog.isListicle && (
        <div className="mt-8 grid gap-6 sm:grid-cols-2 justify-center">
          {blog?.blogListData?.map((item) => (
            <div
              key={item._id}
              className="bg-white mt-2 w-full rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              {blog?.headerImage && (
                <img
                  src={blog.blogListType === "poi" ? item.images[0] : item.image[0]}
                  alt="Blog Cover"
                  className="w-full h-48 object-cover rounded-t-xl"
                />
              )}
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">
                  {
                    language === "ar"?
                    blog.blogList.find(
                      (i) => i.blogListId.toString() === item._id.toString()
                    )?.ar_title
                    :
                    blog.blogList.find(
                      (i) => i.blogListId.toString() === item._id.toString()
                    )?.title
                  }
                </h3>

                <div
                  dangerouslySetInnerHTML={{
                    __html: language === "ar"? 
                    blog.blogList.find(
                      (i) => i.blogListId.toString() === item._id.toString()
                    )?.ar_description
                    :
                    blog.blogList.find(
                      (i) => i.blogListId.toString() === item._id.toString()
                    )?.description,
                  }}
                  className="mt-4 text-sm sm:text-base leading-relaxed"
                />

                <div className="mt-3">
                  <Link
                    to={
                      blog.blogListType === "poi"
                        ? `/${language === "ar" ? "ar" : "en"}/place/${item?.cityData?.name.toLowerCase().replace(/\s+/g, "-")}/${`${item.slug}-${item?.cityData?.name}-${item?.countryData?.name}-poi-${item._id}`.toLowerCase().replace(/\s+/g, "-")}`
                        : blog.blogListType === "city"
                          ? `/${language === "ar" ? "ar" : "en"}/trip/${item?.slug?.toLowerCase().replace(/\s+/g, "-")}-tourism-${item?.country?.name?.toLowerCase().replace(/\s+/g, "-")}-${item._id}-ctytsmid`
                          : `/blog/${item._id}`
                    }
                    className="inline-flex border-2 bg-[#5B27D5] px-3 py-2 items-center gap-1 text-white hover:underline text-sm rounded-md"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  ) : (
    <p className="text-lg text-red-500">Blog not found.</p>
  )}
    <div className="flex flex-col sm:flex-row justify-between text-sm font-semibold mt-5 text-gray-400 mb-2">
      <span>
Last updated on:{' '}
{blog?.updatedAt
? new Intl.DateTimeFormat('en-GB', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(blog.updatedAt))
: 'N/A'}
</span>

      </div>
</div>



</div>
{/* Mobile Trending */}
<div className="w-full mt-2 lg:hidden">
  <h2 className={`text-xl font-semibold mb-4 ${language === "ar" ? "text-right" : "text-left"}`}>
    {language === "ar" ? "المدونات الرائجة" : "Trending Blogs"}
  </h2>
  <div 
    className={`flex w-full gap-4 overflow-x-auto bg-gradient-to-r from-yellow-50 to-white rounded-lg px-2 ${
      language === "ar" ? "flex-row-reverse" : "flex-row"
    }`}
    dir={language === "ar" ? "rtl" : "ltr"}
  >
    {trendingBlogs.length > 0 ? (
      trendingBlogs.map((post) => (
        <div 
          key={post._id}
          className={`min-w-[85vw] md:min-w-[40vw] ${
            language === "ar" ? "pe-2" : "ps-2"
          }`}
        >
          <Link to={`/blog/${post._id}`}>
            <div className="relative aspect-video">
              <img 
                src={post.headerImage[0]?.thumbUrl || "/images/latestBlog.png"} 
                alt="Blog Cover" 
                className="w-full h-full object-cover rounded-t-xl"
              />
            </div>
            <div className={`mt-2 ${language === "ar" ? "text-right" : "text-left"}`}>
              <p className="font-medium text-lg line-clamp-2">
                {language === "ar" ? truncateText(post?.ar_title, 50) : truncateText(post?.title, 50)}
              </p>
              <div 
                className={`text-gray-500 mt-2 text-sm line-clamp-3 ${
                  language === "ar" ? "text-right" : "text-left"
                }`}
                dir={language === "ar" ? "rtl" : "ltr"}
              >
                {language === "ar" 
                  ? truncateText(post?.ar_subDescription, 110)
                  : truncateText(post?.subDescription, 110)}
              </div>
            </div>
          </Link>
        </div>
      ))
    ) : (
      <p className="text-gray-500 p-4">
        {language === "ar" ? "جاري تحميل المدونات..." : "Loading trending blogs..."}
      </p>
    )}
  </div>
</div>
</div>
      )}

      <Footer />
    </div>
  );
}

export default BlogDetails;
